import { render, staticRenderFns } from "./MovementsContentFilter.vue?vue&type=template&id=4ba2488f&"
import script from "./MovementsContentFilter.vue?vue&type=script&lang=js&"
export * from "./MovementsContentFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports